import { keyArea } from "./area";
import type {
  RootProps,
  StyleTemplate,
  StyleTemplates,
} from "./CSSGridTemplate.types";
import type { AreaComponent, Name } from "./area";
import type { Template, Templates } from "./areas";

const defaultName: Name = ".";

const namesReducer = (names: Name[], AreaComponent: AreaComponent): Name[] =>
  names.concat((AreaComponent && AreaComponent[keyArea]) || defaultName);

/**
 * @param {Array}   template       Example: [, AreaComponentA, , , , AreaComponentB, AreaComponentB, , , AreaComponentC, , ,]
 * @return {String}                Example: '. a . . . b b . . c . .'
 */
const getStyleTemplate = (template: Template): StyleTemplate =>
  Array.from(template)
    .reduce(namesReducer, [] as Name[])
    .join(" ");

const getStyleTemplates = (templates: Template[]): StyleTemplates =>
  templates.reduce(
    (styles, template) => styles.concat(`'${getStyleTemplate(template)}' 1fr`),
    [] as StyleTemplates,
  );

export const getTemplates = (
  breakpointTemplates: Templates,
): RootProps["templates"] => {
  const entries = Object.entries(breakpointTemplates).map(
    ([breakpoint, templates]) => [breakpoint, getStyleTemplates(templates)],
  );

  return Object.fromEntries(entries);
};
